import { Text, View } from "react-native";
import { useRouter } from "expo-router";

import DiscordLogo from "~/assets/discord-logo.svg";
import { isWeb } from "~/lib/constants";
import { supabaseClient } from "~/lib/supabase";
import { useGlobalStore } from "~/stores/global";
import { Dropdown } from "~/ui/Dropdown";
import { AccountAvatar } from "./AccountAvatar";

export function UserDropdown() {
  const {
    store: { personalAccount },
  } = useGlobalStore(true);

  const { push, replace } = useRouter();

  return (
    <View>
      <Dropdown
        align="end"
        trigger={
          <AccountAvatar
            avatar={personalAccount?.avatarUrl}
            fallbackText={personalAccount?.displayName || personalAccount?.slug}
          />
        }
        groups={[
          {
            items: [
              {
                key: "settings",
                title: "Account Settings",
                icon: {
                  ios: "gear",
                  web: "settings",
                },
                onSelect: () => {
                  push({
                    pathname:
                      "/(app)/(authenticated)/[account]/(account)/settings",
                    params: {
                      account: personalAccount!.slug,
                    },
                  });
                },
              },
              {
                key: "roadmap",
                title: "Roadmap",
                icon: {
                  ios: "map.fill",
                  web: "map",
                },
                onSelect: () => {
                  if (isWeb) {
                    window.open("https://savepad.app/roadmap", "_blank");
                  } else {
                  }
                },
              },
              {
                key: "changelog",
                title: "Changelog",
                icon: {
                  ios: "gift",
                  web: "gift",
                },
                onSelect: () => {
                  if (isWeb) {
                    window.open("https://savepad.app/changelog", "_blank");
                  } else {
                  }
                },
              },
              {
                key: "support",
                title: (
                  <View className="flex-row items-center gap-2">
                    <Text>Support</Text>
                  </View>
                ),
                iconComponent: <DiscordLogo className="h-4 w-4" />,

                onSelect: () => {
                  if (isWeb) {
                    window.open(
                      "https://discord.com/invite/27DK8YTa",
                      "_blank",
                    );
                  } else {
                  }
                },
              },
              {
                key: "logout",
                title: "Log Out",
                icon: {
                  ios: "power",
                  web: "power",
                },
                destructive: true,
                onSelect: () => {
                  supabaseClient.auth.signOut().then(() => {
                    replace({ pathname: "/(app)/auth/login" });
                  });
                },
              },
            ],
          },
        ]}
      />
    </View>
  );
}
